import React, { useEffect, useRef, useState } from "react";

/**
 * ScaledFrame renders its children at a fixed intrinsic size (width x height)
 * and uniformly scales them down to fit the parent container width on
 * smaller viewports. Keeps the design pixel-perfect and prevents layout
 * breakage on mobile.
 */
const ScaledFrame = ({ width, height, children, className = "" }) => {
  const wrapRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const update = () => {
      const w = el.clientWidth;
      const s = Math.min(1, w / width);
      setScale(s);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [width]);

  return (
    <div
      ref={wrapRef}
      className={`w-full ${className}`}
      style={{ height: height * scale }}
    >
      <div
        style={{
          width,
          height,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ScaledFrame;
